// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__KNX4B","body":"NotFound_body__Yp2rP","btn":"NotFound_btn__2yjp1"};